import React from 'react';
import { SignatureDrawer } from './signature-drawer';
import { classes } from '../stylesheets/signature-wut.st.css';
import { ForcedState, useForcedState } from '../../../contexts/forced-state-context';
import classNames from 'classnames';
import { TextFieldTheme } from 'wix-ui-tpa/cssVars';
import { ExternalImageWUT } from './external-image-wut';
import { getSignaturePenColorWUT, isExternalImage } from '../utils/drawer';
import { useConfig } from '../../../contexts/config-context';
export function SignatureDrawerWUT(_ref) {
  let {
    inputId,
    fieldId,
    ariaDescribedBy,
    ariaLabelledBy,
    onChange,
    onBlur,
    value,
    hasError,
    required,
    handleBeforeChange
  } = _ref;
  const {
    compId,
    isRTL: rtl
  } = useConfig();
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const externalImage = value && isExternalImage(value) ? /*#__PURE__*/React.createElement(ExternalImageWUT, {
    value: value
  }) : undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    onBlur: onBlur
  }, /*#__PURE__*/React.createElement(SignatureDrawer, {
    onChange: onChange,
    className: classNames(classes.drawer, classes.theme, {
      [classes.error]: hasError,
      [classes.hover]: forcedHover
    }),
    penColor: getSignaturePenColorWUT(compId),
    value: value,
    theme: TextFieldTheme.Box,
    rtl: rtl,
    inputId: inputId,
    fieldId: fieldId,
    externalImage: externalImage,
    onBeforeChange: handleBeforeChange,
    "aria-required": required,
    "aria-labelledby": ariaLabelledBy,
    "aria-describedby": ariaDescribedBy
  }));
}
//# sourceMappingURL=signature-drawer-wut.js.map